import { useMutation } from "@apollo/client";
import React, { useMemo } from "react";
import { BsHeartFill, BsHeart } from "react-icons/bs";
import { PiChatTeardropThin } from "react-icons/pi";
import { CREATE_FEED_LIKES, DELETE_FEED_LIKES } from "../../apollo/operations";
import { FeedLikeType, UserFeedsType } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { UserActivityReader } from "..";
import { setLikedPost } from "../../redux/slices/communityFeedSlice";

type UserActivityProps = {
  textArea: React.RefObject<HTMLTextAreaElement | null>;
  openModal?: boolean;
  onOpen?: () => void;
  refetch: () => void;
  user: any;
  userFeed: UserFeedsType | undefined;
  feedLikes: FeedLikeType | undefined;
  inputArea: React.RefObject<HTMLInputElement | null>;
  refetchAllUserFeeds: () => void;
  setLoadings: React.Dispatch<React.SetStateAction<boolean>>;
  setModalRemove: React.Dispatch<React.SetStateAction<boolean>>;
};
const UserActivity: React.FC<UserActivityProps> = ({
  textArea,
  onOpen,
  openModal,
  userFeed,
  inputArea,
  refetchAllUserFeeds,
  setLoadings,
  feedLikes,
  refetch,
  setModalRemove,
  // comfeedId
}) => {
  const user = useSelector((state: any) => state.user.userDetails);
  // const [loadings, setLoadings] = React.useState(false);
  const [showDetailedLikes, setShowDetailedLikes] = React.useState(false);
  const [deleteLikeLoading, setDeleteLikeLoading] = React.useState(false);
  const [createLikeLoading, setCreateLikeLoading] = React.useState(false);

  const specificUserLike = userFeed?.feedLikes?.find(
    (a) => a.likedBy.id === user.id
  );

  const Liker =
    userFeed &&
    userFeed?.feedLikes?.find((a) => {
      return a.likedBy.id === specificUserLike?.likedBy.id;
    });
  // console.log(specificUserLike, "specificUserLike");

  // console.log(Liker?.id, "Liker");

  const [deleteFeedLikes] = useMutation(DELETE_FEED_LIKES, {
    onCompleted: (data) => {
      // console.log(data);
      console.log("like removed");
      refetch();
    },
    onError: (err) => {
      const errMsg = err.graphQLErrors[0].extensions?.originalError;
      console.log(errMsg);
      console.log(err);
    },
  });

  const handleDelete = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoadings(true);
    setModalRemove(true);
    setDeleteLikeLoading(true);
    setShowDetailedLikes(false);
    if (Liker?.likedBy.id && Liker.id) {
      await deleteFeedLikes({
        variables: {
          where: {
            id: Liker?.id,
          },
        },
      })
        .then(() => {
          console.log(`successfully removed ${Liker?.id}`);
          refetchAllUserFeeds();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const [createFeedLikes] = useMutation(CREATE_FEED_LIKES, {
    onCompleted: (data) => {
      // console.log(data);
      refetch();
    },
    onError: (err) => {
      console.log(err);
      const errorMsg = err?.graphQLErrors[0].extensions?.originalError;
      console.log(errorMsg);
    },
  });

  const handleLikes = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoadings(true);
    setCreateLikeLoading(true);
    setShowDetailedLikes(false);
    try {
      if (user.id) {
        await createFeedLikes({
          variables: {
            data: {
              userFeed: {
                id: userFeed?.id,
              },
              likedBy: {
                id: user?.id,
              },
            },
          },
        }).then(() => {
          refetchAllUserFeeds();
        });
        console.log("likes created");
      }
    } catch (error) {
      console.error("Error creating likes:", error);
    }
  };

  const dispatch = useDispatch();
  //  This button links the chat Icon to the text area input.
  const handleTextAreaBt = () => {
    const isLargeScreen = window.innerWidth >= 976; // You may adjust this value based on Tailwind's lg breakpoint

    if (textArea && textArea.current && isLargeScreen) {
      textArea.current.focus(); // Focus on the textarea
      console.log("Textarea clicked");
    } else if (inputArea && inputArea.current) {
      inputArea.current.focus();
      console.log("Input clicked");
    }
  };
  useMemo(() => {
    if (!Liker?.id) {
      setDeleteLikeLoading(false);
    }
    if (Liker?.id) {
      setCreateLikeLoading(false);
    }
  }, [Liker?.id]);

  const Reader = (
    <UserActivityReader
      onOpen={onOpen}
      userFeed={userFeed}
      user={user}
      deleteLikeLoading={deleteLikeLoading}
      createLikeLoading={createLikeLoading}
      setShowDetailedLikes={setShowDetailedLikes}
      showDetailedLikes={showDetailedLikes}
    />
  );

  return (
    <>
      {openModal === false && Reader}
      <div className="w-full lg:px-4">
        <div className="flex justify-between border-t border-[#CCC] lg:h-10 pt-3">
          <div className="flex gap-4">
            {userFeed?.id && (
              <>
                {createLikeLoading || deleteLikeLoading ? (
                  createLikeLoading ? (
                    <BsHeartFill size={22} color="red" className="mt-1" />
                  ) : (
                    deleteLikeLoading && <BsHeart size={22} className="mt-1" />
                  )
                ) : Liker?.likedBy.id ? (
                  <button onClick={handleDelete}>
                    <BsHeartFill
                      size={22}
                      color="red"
                      className="cursor-pointer mt-1"
                    />
                  </button>
                ) : (
                  <button onClick={handleLikes}>
                    <BsHeart size={22} className="cursor-pointer mt-1" />
                  </button>
                )}
              </>
            )}

            <PiChatTeardropThin
              size={27}
              onClick={() => {
                if (openModal) {
                  handleTextAreaBt();
                } else {
                  if (onOpen) onOpen();
                  dispatch(setLikedPost(feedLikes));
                  refetchAllUserFeeds();
                }
              }}
              className="mt-px cursor-pointer"
            />
            {/* : <PiChatTeardropThin size={27} onClick={onOpen} className="mt-px cursor-pointer"/>} */}
            {/* <CiLocationArrow1 size={27} className="mt-px cursor-pointer"/> */}
          </div>
          {/* <div className="pt-1">
      <BsBookmark size={22}/>
    </div> */}
        </div>
      </div>
    </>
  );
};

export default UserActivity;
